import React, { useState, useEffect } from "react";
import styles from "./rapolasLogo.module.scss";

export default function RapolasLogo() {
  return (
    <div className={styles.logoBackground}>
      <div className={styles.logoS}>
        S <span className={styles.logoR}>R</span>
      </div>
    </div>
  );
}
